import React from "react";
import "./HowItWorks.css";
import useReveal from "../hooks/useReveal";
import roadImage from "../images/a.png";

const STEPS = [
  {
    title: "List the places",
    body: "Start and finish are fixed. Everything in between is just a stop — add up to twelve of them in any order you happen to remember.",
  },
  {
    title: "Let it reorder",
    body: "A nearest-neighbour pass builds a first route, then 2-opt untangles the crossings it leaves behind.",
  },
  {
    title: "Drive the short way",
    body: "You get the stop order, the distance for every leg and a rough time on the road before you set off.",
  },
];

const HowItWorks = () => {
  const ref = useReveal();

  return (
    <section className="how section" id="how" ref={ref}>
      <div className="container">
        <div className="how__head">
          <span className="eyebrow reveal">How it works</span>
          <h2 className="how__title reveal">
            Three steps between a messy list and a sensible route.
          </h2>
        </div>

        <ol className="how__grid">
          {STEPS.map((step, index) => (
            <li className="how__card reveal" key={step.title}>
              <span className="how__num">{String(index + 1).padStart(2, "0")}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="how__panel reveal">
          <div className="how__panel-copy">
            <span className="eyebrow">Why it matters</span>
            <h3>
              Twelve stops can be arranged 479&nbsp;million ways. Guessing is
              expensive.
            </h3>
            <p>
              Visiting stops in the order you wrote them down is almost never
              the shortest run. TravelEase checks the arrangement for you, so a
              day of errands stops doubling back on itself.
            </p>
          </div>
          <img
            className="how__panel-art"
            src={roadImage}
            alt="Winding papercraft highway with small cars"
            loading="lazy"
            width="1024"
            height="1024"
          />
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
